import { render, staticRenderFns } from "./Construction.vue?vue&type=template&id=01adcd24&scoped=true"
import script from "./Construction.vue?vue&type=script&lang=js"
export * from "./Construction.vue?vue&type=script&lang=js"
import style0 from "./Construction.vue?vue&type=style&index=0&id=01adcd24&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01adcd24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/moderlab/moderclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01adcd24')) {
      api.createRecord('01adcd24', component.options)
    } else {
      api.reload('01adcd24', component.options)
    }
    module.hot.accept("./Construction.vue?vue&type=template&id=01adcd24&scoped=true", function () {
      api.rerender('01adcd24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/Construction/Construction.vue"
export default component.exports